export default {
  getters: {
    getById: state => id => {
      return state.data[id] ? state.data[id] : null;
    },
    getAll(state) {
      return Object.values(state.data).map(item => ({ ...item }));
    },
  },
};
